import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";

import HomeHeader from "../home/HomeHeader";
import HomeSearch from "../home/HomeSearch";
import HomeCarousel from "../home/HomeCarousel";
import SeoLinks from "../home/SeoLinks";

import HomeFooter from "../home/HomeFooter";
import { useOpenHelpDialogOnScroll } from "../helpDialog/useOpenHelpDialogOnScroll";

const TexasSearchPage = ({ redirectToHome }) => {
    const router = useRouter();
    const [helpDialogOpen, setHelpDialogOpen] = useState(false);
    const [helpButtonMinimized, setHelpButtonMinimized] = useState(false);

    useEffect(() => {
        if (redirectToHome) {
            router.replace("/");
        }
    }, []);

    // Open help dialog once the user scrolls, if it hasn't been shown in the last hour
    useOpenHelpDialogOnScroll(setHelpDialogOpen);

    const handleMinimizeHelpButton = (e) => {
        e.stopPropagation(); // Prevent the button's onClick from firing
        setHelpButtonMinimized(true);
    };

    const handleOpenHelpDialog = () => {
        // Always open the dialog and update the timestamp
        setHelpDialogOpen(true);
        localStorage.setItem("lastHelpDialogShown", Date.now().toString());

        // If button was minimized, expand it
        if (helpButtonMinimized) {
            setHelpButtonMinimized(false);
        }
    };

    return (
        <div className="">
            <HomeHeader fixed={false} />

            <div className="bg-primary-500">
                <div className="container mx-auto py-4 px-4 sm:py-8 sm:px-4 md:px-8 lg:px-16">
                    <div className="text-2xl sm:text-4xl text-white font-bold font-headline mb-4">
                        Find Assisted Living in Texas
                    </div>
                    <div className="">
                        <HomeSearch
                            inputClassName="w-[300px] sm:w-[500px]"
                            enableLocation={false}
                            higherInput={false}
                            buttonColor=" bg-gray-500 border-gray-500 hover:bg-gray-400 hover:border-gray-400"
                        />
                    </div>
                </div>
            </div>

            <div className="pt-8 pb-8 bg-white">
                <div className="container mx-auto px-4 sm:px-4 md:px-8 lg:px-16">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                        <HomeCarousel city="Houston, TX" horizontal={false} />
                        <HomeCarousel city="Dallas, TX" horizontal={false} />
                        <HomeCarousel city="San Antonio, TX" horizontal={false} />
                    </div>
                </div>
            </div>

            <SeoLinks />
            <HomeFooter />
        </div>
    );
};

export default TexasSearchPage;
